import { useFetcher } from 'react-router';

/**
 * Fetcher hook for handlers declared as `const action: ActionFunction` (or similar).
 * Passing `typeof action` to `useFetcher` resolves fetcher data to `never` in v7 because
 * `SerializeFrom` cannot recover data from the widened handler type.
 */
export function useAppFetcher<TData = Record<string, unknown>>(options?: {
    key?: string;
}) {
    return useFetcher<TData>(options);
}
